// extracted by mini-css-extract-plugin
export default {"main":"App_main__xFCrF","content":"App_content__Gwag2","bg":"App_bg__TedgV"};